export default {
  name: 'InvestigationController',
  fn: function($scope, $routeParams, dataService, initialDataInteractor, investigationInteractor, personInteractor, getReportInteractor) {
    const $ctrl = this;
    $ctrl.investigation = {};

    function initializeInstances(investigation) {
      let promises = [];

      investigation.questionnaire_instances.forEach(instance => {
        promises.push(personInteractor.getPerson(instance.participant_id).then(person => {
          instance.participant = person;
        }));
      });

      Promise.all(promises).then(() => $scope.$digest());
    }

    investigationInteractor.getInvestigation($routeParams['id'])
      .then(investigation => {
        $ctrl.investigation = investigation;
        initializeInstances(investigation);
      });

    $ctrl.instanceReportUrl = function (instance) {
      return getReportInteractor.getReportUrlFor(instance);
    }
  }
};
